import React, { useState, useEffect } from 'react';
import './editDialog.css';
import { Button } from 'semantic-ui-react';
import TextareaAutosize from 'react-textarea-autosize';

const EditDialog = ({ node, onSave, onCancel }) => {
  const [editedNode, setEditedNode] = useState({
    type: (node && node.type) || '',
    emotion: (node && node.emotion) || '',
    content: (node && node.content) || '',
    speaker: (node && node.speaker) || ''
  });

  useEffect(() => {
    setEditedNode({
      type: (node && node.type) || '',
      emotion: (node && node.emotion) || '',
      content: (node && node.content) || '',
      speaker: (node && node.speaker) || ''
    });
  }, [node]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedNode({
      ...editedNode,
      [name]: value,
    });
  };

  const handleSave = () => {
    onSave({
      ...editedNode,
      uniqueKey: editedNode.uniqueKey || `new_${Date.now()}` // Generate a uniqueKey if not provided
    });
  };


  const getSpeakerFromType = (node) => {
    switch (node.type) {
      case "dialogue":
        return node.speaker;
      case 'narration':
        return "Narrator";
      case "initialize":
        return "Initializing";
      case "bookPart":
        return "Book Part";
      case "chapter":
        return "Chapter";
      default:
        return node.type;
    }
  }
  const getSpeakerType = (node) => {
    switch (node.type) {
      case "dialogue":
        return "Dialogue";
      case 'narration':
        return "Narrator";
      case "initialize":
        return "Initializing";
      case "bookPart":
        return "Book Part";
      case "chapter":
        return "Chapter";
      default:
        return node.type;
    }
  }
  return (
    <div className="edit-dialog">
      <div style={{ position: "absolute", top: "28px", right: "30px" }}>
        <Button basic size="mini" color="blue" onClick={handleSave}>Save</Button>
        <Button basic size="mini" color="red" onClick={onCancel}>Cancel</Button>
      </div>
      <div className="input-group">
        <div className="input-field">
          <label>{getSpeakerType(editedNode)}:</label>
          <input
            type="text"
            name="speaker"
            value={getSpeakerFromType(editedNode)}
            onChange={handleChange}
          />
        </div>
        <div className="input-field">
          <label>Emotion:</label>
          <input
            type="text"
            name="emotion"
            value={editedNode.emotion ? editedNode.emotion : "Neutral"}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="input-field textEditBox">
        <label>Text:</label>
        <TextareaAutosize
          minRows={2}
          name="content"
          value={editedNode.content}
          onChange={handleChange}
          style={{ paddingTop: "25px" }}
        />
      </div>
    </div>
  );
};

export default EditDialog;
